import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isAdmin } from "../../../Constants/constants";
import { setMakePaymentRoute } from "../../../Redux/Slices/PageSlice";
import { getBannerMessageByKey } from "../../../Services/helper";
import { HomepageNewBanners } from "../../../Pages/Home/Components/HomepageNewBanners/HomepageNewBanners";
import { Theme } from "../../../Styles/GlobalTheme";

function InactiveAccountBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentDueBalance, isSuspended } = useSelector((state: any) => state.customerPlanDetails);
  const { inactivatePaymentStatus } = useSelector((state: any) => state.paymentDetails);
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const INACTIVE_ACCOUNT_ZERO_BALANCE_MESSAGE = getBannerMessageByKey(
    "inactive-account-zero-balance",
    sideCoreBannerMessages
  );
  const INACTIVE_ACCOUNT_MESSAGE = getBannerMessageByKey(
    "inactive-account",
    sideCoreBannerMessages
  );
  const SUSPENDED_ACCOUNT_MESSAGE = getBannerMessageByKey(
    "suspended-account",
    sideCoreBannerMessages
  );

  const handlePayNow = () => {
    navigate("/billing/makeapayment");
    dispatch(setMakePaymentRoute(location?.pathname));
  };

  const isZeroOrNegativeBalance =
    inactivatePaymentStatus || parseInt(currentDueBalance) <= 0 || currentDueBalance === null;
  const showPayButton = !isZeroOrNegativeBalance && parseInt(currentDueBalance) > 0;
  const bannerMessage = isSuspended
    ? SUSPENDED_ACCOUNT_MESSAGE
    : isZeroOrNegativeBalance
    ? INACTIVE_ACCOUNT_ZERO_BALANCE_MESSAGE
    : INACTIVE_ACCOUNT_MESSAGE;

  return (
    <HomepageNewBanners
      content={bannerMessage?.content}
      actionItem={showPayButton ? "MAKE A PAYMENT" : undefined}
      onActionHandle={showPayButton ? handlePayNow : undefined}
      actionItemStyles={{ color: Theme.palette.customcolor.whiteColor, textDecoration: "none", background: Theme.palette.secondary.main, border: "none", cursor: "pointer" }}
      disabled={isAdmin}
      bannerType="warning"
    />
  );
}

export default InactiveAccountBanner;
 